import axios from 'axios'

// Send tickets via mail
const send = async (email, tickets) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/mail/ticket`, { email, tickets })
  return data
}

// Send invite via mail
const mailInvite = async (tiket, email) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/mail/invite`, { tiket, email })
  return data
}

export {
  send,
  mailInvite
}
